// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"245":"aecfe591","837":"aecfe591"}[chunkId] + ".css";
};